import React, { Component } from 'react'
import SearchBar from '../commons/SearchBar/SearchBar.container'
import Slider from '../../components/Slider'
import SliderHomeResponsive from '../../components/Slider/responsive'
import Newsletter from '../../containers/NewsletterWidget'
import News from '../PageHome/components/Noticias'
import Neighborhood from './components/Neighborhoods/Neighborhoods.container'
import Imis from '../commons/SliderMarketReports/imi'
import { translate } from 'react-translate'
import Brokers from '../../components/Brokers'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'

@translate('Residencial')
class Residencial extends Component {

  UNSAFE_componentWillMount() {
    this.props.didMount({ id: '6', name: 'Residencial'})
    window.scrollTo(0, 0)
  }

  componentDidMount(){
    window.location.hash = window.decodeURIComponent(window.location.hash)
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#')
      if (hashParts.length === 2) {
        const hash = hashParts.slice(-1)[0]
        document.querySelector(`#${hash}`).scrollIntoView()
      }
    }
    scrollToAnchor()
    window.onhashchange = scrollToAnchor
  }

  render () {

    const { relevantsList, newsList, directors, imis, t } = this.props

    return (
      <div className='container-fluid'>
        <MainBanner
          backgroundURL={'/assets/images/residencial-search.jpg'}
          mainTitle={t('Division_Residencial')}
        >
          <SearchBar section='Residentail' />
        </MainBanner>
        <div className='slider-container'>
          <div className='text-center title-slide'>{t('Propiedades_Destacadas')} </div>
          <div className='hidden-xs'>
            <Slider properties={relevantsList} />
          </div>
          <div className='visible-xs box-slider'>
            <SliderHomeResponsive items={relevantsList} />
          </div>
        </div>
        <div className='neighborhoods-container' id='barrios' name='barrios'>
          <div className='text-center title-slide'>{t('Barrios')}</div>
          <Neighborhood />
        </div>
        {/* <div className='border-top'>
          <div className='text-center title-slide'>{t('Directorio')}</div>
          <Brokers brokers={directors}/>
        </div> */}
        {(imis.length > 0) ?
          <div className='imis-container'>
            <Imis imis={imis}/>
          </div> : '' }
        <div className='form-newsletter-container'>
          <Newsletter />
        </div>
        {(newsList.length > 0) ?
          <News news={newsList} />
        : '' }
      </div>
    )
  }
}

export default Residencial



// WEBPACK FOOTER //
// ./src/features/PageResidential/PageResidential.component.js